<template>
    <div class="signin">
        <v-card-title>ログイン</v-card-title>
        <v-text-field placeholder="Username" v-model="username"></v-text-field>
        <v-text-field type="password" placeholder="Password" v-model="password"></v-text-field>
        <v-btn @click="signIn">ログイン</v-btn>
        <p>アカウントを持っていない場合
            <router-link to="/signup">新規登録</router-link>
        </p>
    </div>
</template>

<script>
    import firebase from 'firebase'
    export default {
        name: 'Signin',
        data () {
            return {
                username: '',
                password: ''
            }
        },
        methods: {
            signIn: function () {
                firebase.auth().signInWithEmailAndPassword(this.username, this.password)
                    .then(() => {
                        //alert('Success!')
                        this.$router.push('/')
                    })
                    .catch(error => {
                        alert(error.message)
                    })
            }
        }
    }
</script>
